import { ProviderLogo } from '../components/provider-logo';
import React, { useMemo } from 'react';
export const useProviderLogo = (props) => {
    return useMemo(() => React.createElement(ProviderLogo, { ...props }), [props]);
};
